import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import styles from './style.css';

@inject('store', 'localizationStore')
@observer
class Avatar extends Component {
    fileInput = React.createRef()
    onFileChanged = (event) => {
        this.props.onChange(event.target.files[0])
    }
    onDragOver = (event) => {
        event.preventDefault()
    }
    onDrop = (event) => {
        event.preventDefault()

        let file = event.dataTransfer.files[0]
        if(file !== undefined && file.type.match('image/*') != null){
            this.props.onChange(file)
        }

        // event.dataTransfer.clearData()
    }
    render() {
        const locale = this.props.localizationStore.locale
        let containerProps = {
            style: {
                width: this.props.size + 'px',
                height: this.props.size + 'px',
                borderWidth: this.props.borderWidth + 'px'
            }
        }
        let imgProps = {
            style: {
                width: this.props.size - this.props.borderWidth * 4 + 'px',
                height: this.props.size - this.props.borderWidth * 4 + 'px'
            },
            className: styles.avatar
        }
        if (this.props.onChange !== undefined) {
            imgProps.className = styles.changeable
            imgProps.onClick = () => {
                this.fileInput.current.click()
            }
            containerProps.onDragOver = this.onDragOver
            containerProps.onDrop = this.onDrop
        }
        return (
            <div className={styles.container} {...containerProps}>
                {this.props.onChange !== undefined &&
                    <div className={styles.textLabel}>
                        {locale.change_avatar}
                    </div>
                }
                <img alt='avatar'
                     src={this.props.avatar !== undefined  && this.props.avatar}
                     {...imgProps}
                />

                <input className={styles.fileInput}
                       ref={this.fileInput}
                       type='file'
                       onChange={this.onFileChanged}
                       accept='image/*'
                />
            </div>
        );
    }
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/components/Avatar/index.js